/* eslint-disable no-undef */
/* eslint-disable object-shorthand */
/* prettier-ignore */
(function() {
  if (!window.postMessage || !window.JSON || !document.addEventListener) {
    return;
  }

  /*
   * API для работы с iframe из родительского окна.
   */
  webim.api = {
    /*
     * Инициализация переменных, навешивание событий, необходимых для корректной работы чата.
     */
    init: function() {
      init();
    },

    chat: {
      /*
       * Проброс события старта чата из родительского окна в iframe с чатом.
       */
      start: function() {
        postMessage('webim.api.chat.start');
      },
      /*
       * Проброс события закрытия чата из родительского окна в iframe с чатом.
       */
      close: function() {
        postMessage('webim.api.chat.close');
      },
    },
    /*
     * Проброс новых идентификационных данных пользователя из родительского окна в iframe с чатом.
     * Необходимо для поддержки авторизации и выхода пользователя из системы без перезагрузки страницы.
     */
    onProvidedVisitorChanged: function() {
      postMessage('webim.api.onProvidedVisitorChanged', webim_visitor);
    },
  };

  let initInvoked = false;
  /*
   * Инициализация переменных, навешивание событий, необходимых для корректной работы чата.
   */
  function init() {
    /*
     * Инициализация пути, по которому будет загружаться в iframe страница с чатом.
     */
    initIframeSrc();

    if (initInvoked) {
      return;
    }
    initInvoked = true;

    /*
     * Прослушивание события 'message', с помощью которого iframe с чатом передает данные на родительскую страницу сайта.
     * Данные из данного события парсятся и передаются в необходимый обработчик (https://webim.ru/kb/dev/8274-iframe/).
     */
    window.addEventListener('message', function(e) {
      if (e.origin === 'https://' + webim.domain) {
        try {
          let data = JSON.parse(e.data);
          if (data.cmd === 'handler') {
            let params = data.params;
            if (params.handlerName in webimHandlers) {
              webimHandlers[params.handlerName](params.event);
            }
          }
          // eslint-disable-next-line no-empty
        } catch (e) {

        }
      }
    });

    /*
     * Прослушивание события 'focus' родительской страницы и передача информации об этом в iframe с чатом.
     * Необходимо для понимания, находится посетитель на странице или нет.
     */
    window.addEventListener('focus', function() {
      postMessage('window.focus');
    });

    /*
     * Прослушивание события 'blur' родительской страницы и передача информации об этом в iframe с чатом.
     * Необходимо для понимания, покинул посетитель страницу или нет.
     */
    window.addEventListener('blur', function() {
      postMessage('window.blur');
    });

    /*
     * Если есть поддержка History.js, то прослушиваем событие 'statechange'.
     * Необходимо для передачи информации о смене страницы в iframe с чатом (отображается оператору).
     */
    if (typeof window.History != 'undefined' && typeof window.History.Adapter != 'undefined') {
      window.History.Adapter.bind(window, 'statechange', function() {
        postMessage('pageChanged', { title: document.title, url: document.location.href });
      });
    }
  }

  /*
   * Вспомогательная функция для получения страницы с чатом из iframe.
   */
  function getChatIframeWindow() {
    let elem = document.getElementById('webim-chat-iframe');

    if (!elem) {
      return;
    }

    return elem.contentWindow;
  }

  /*
   * Инициализация пути, по которому будет загружаться в iframe страница с чатом.
   */
  function initIframeSrc() {
    let url = 'https://' + webim.domain + '/iclient.php?small-screen=' + (isSmallScreen() ? '1' : '0');
    if (webim.location) {
      url += '&location=' + webim.location; // размещение
    }
    // страница на которой начат чат (отображается оператору)
    url += '&start-page=' + encodeURIComponent(JSON.stringify({ title: document.title, url: document.location.href }));
    if (window.webim_visitor) {
      // идентификационные данные пользователя
      url += '&provided-visitor=' + encodeURIComponent(JSON.stringify(window.webim_visitor));
    }
    if (window.webim_auth_token) {
      // токен, используемый для server-to-server авторизации
      url += '&provided-auth-token=' + encodeURIComponent(window.webim_auth_token);
    }
    document.getElementById('webim-chat-iframe').setAttribute('src', url);
  }

  /*
   * Проверка размера родительского окна.
   * В случае небольшого окна (смартфоны и маленькие планшеты) чат будет открыт в новом окне.
   */
  function isSmallScreen() {
    let matchMedia = window.matchMedia || window.msMatchMedia;
    let query = matchMedia
      ? matchMedia('screen and (max-device-width: 1024px) and (orientation: landscape), screen and (max-device-width: 768px) and (orientation: portrait)')
      : false;

    return query && query.matches;
  }

  /*
   * "Системная" функция для пересылки данных из родительского окна в iframe с чатом.
   */
  function postMessage(command, params) {
    let iframeWindow = getChatIframeWindow();

    if (!iframeWindow) {
      return;
    }

    let message = { cmd: command };
    if (params) {
      message.params = params;
    }
    iframeWindow.postMessage(JSON.stringify(message), 'https://' + webim.domain);
  }
})();
